import {featuresDefinition} from '~/adapters/signaler/signalerFeatureFlags';

export function getActiveTests() {
  return Object.keys(featuresDefinition).filter(key => {
    const flags = featureFlags[key].flags;
    return !Object.keys(flags).some(group => flags[group] === 1);
  });
}

export function noop() {}
